import React from 'react';
import styled from 'styled-components';
import TreeSelect from './TreeSelect';
const SentenceSelect = (props) => {
    return (React.createElement(React.Fragment, null, props.sentenceBuilder(props.values).map((part, i) => {
        if (typeof part === 'string') {
            return React.createElement(Text, null, part);
        }
        const { value: key } = part;
        const options = props.options[key];
        const selected = props.values[key];
        return (React.createElement(React.Fragment, null,
            React.createElement(TreeSelect, { key: String(key), options: options, value: options.find((o) => o.value === selected) || options[0], onChange: (s) => {
                    props.onChange(Object.assign(Object.assign({}, props.values), { [key]: s }));
                } })));
    })));
};
const Text = styled.span `
  line-height: 1.5;
`;
export default SentenceSelect;
//# sourceMappingURL=SentenceSelect.js.map